namespace $ {

	export type $shm_projects_changes_item = {
		title?: string
		description?: string
	}

	export function $shm_projects_changes_summary(
		history: readonly { changes?: readonly $shm_projects_changes_item[] }[],
		fallback: readonly $shm_projects_changes_item[] = [],
	) {
		const source = history.flatMap( iteration => iteration.changes ?? [] )
		const changes = source.length ? source : fallback
		const seen = new Set< string >()
		const lines: string[] = []

		for( const change of changes ) {
			const title = String( change.title || '' ).trim()
			const description = String( change.description || '' ).trim()
			if( !title && !description ) continue
			const key = `${ title }\n${ description }`
			if( seen.has( key ) ) continue
			seen.add( key )
			lines.push( `- ${ title || description }${ title && description && description !== title ? ` — ${ description }` : '' }` )
		}

		return lines.join( '\n' )
	}

}
